import React from 'react';
/* import './Home.css'; */
import { Link } from "react-router-dom";
import Domestic from './Image/Domestic.avif'
const Footer = () => {
  return (
    <div className="mainHome-container">
    
    <section className="product-categories" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>Our Trading Operations</h2>
      <p>Learn about our comprehensive domestic and international trading services</p>
      <div className="tranding-mid-container">
        <div className="tranding-mid-container-contact-left">
            <div className="tranding-pics">
                <img src={Domestic} alt="" className='tranding-left-pics' />
            </div>

        </div>

        <div className="tranding-mid-container-contact-right">
            <div className='tranding-tittle'>
                Domestic Trading
            </div>
            <div className='tranding-mid-details'>
            Our domestic trading operations connect local suppliers with buyers across the country, ensuring efficient and cost-effective solutions for metal scrap and agricultural products.


            </div>
            <div className="tranding-mid-details-content-box">
                <div className="tranding-mid-details-content-box-title">Nationwide Network</div>
                <div className="tranding-mid-details-content-box-details">Extensive network of collection centers, warehouses, and logistics partners across the country.</div>
            </div>
            <div className="tranding-mid-details-content-box">
                <div className="tranding-mid-details-content-box-title">Efficient Collection</div>
                <div className="tranding-mid-details-content-box-details">Streamlined collection processes for all types of metal scrap and agricultural products.

        </div>
        </div>
            <div className="tranding-mid-details-content-box">
                <div className="tranding-mid-details-content-box-title">Quality Assurance</div>
                <div className="tranding-mid-details-content-box-details">Rigorous quality control measures to ensure all products meet required specifications.</div>
            </div>
            
        </div>
      </div>
      
      <ul style={{display:'flex',listStyle:'none',gap:'20px',justifyContent:'center'}}>
        <li style={{fontWeight:'semibold'}}>Looking for International Trading?</li>
        <li  ><Link to="/international-trading" style={{color:"orange"}}>View International Trading Services</Link></li>
      </ul>
       
      
    </section>
    
    </div>
  );
};

export default Footer;

